var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40918 25.4299H27.1137M3.38645 1.70264V25.4299M17.2274 1.70264V25.4299M25.1365 7.63445V25.4299M7.341 6.64582H8.32963M7.341 10.6004H8.32963M7.341 14.5549H8.32963M12.2842 6.64582H13.2728M12.2842 10.6004H13.2728M12.2842 14.5549H13.2728M7.341 25.4299V20.981C7.341 20.1625 8.00536 19.4981 8.82395 19.4981H11.7899C12.6085 19.4981 13.2728 20.1625 13.2728 20.981V25.4299M2.39782 1.70264H18.216M17.2274 7.63445H26.1251M21.1819 12.5776H21.1925V12.5882H21.1819V12.5776ZM21.1819 16.5322H21.1925V16.5427H21.1819V16.5322ZM21.1819 20.4867H21.1925V20.4973H21.1819V20.4867Z",
    stroke: "#6E6C6C",
    strokeWidth: 1.97727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/Listing.21a9e1d6e87adb782cf9570a2763c069.svg";
export { ForwardRef as ReactComponent };